import React from "react";
import { CouponIcon } from "../../general/Icons";
import Currency from "../../general/Currency";

const DiscountAdjustment = ({
  label,
  amount,
  type = "promo",
  refunds = [],
}) => {
  const refundedAmount =
    refunds?.reduce((total, refund) => total + refund.amount, 0) || 0;
  const displayAmount = Math.abs(amount - refundedAmount);

  return (
    <div
      className="bg-white pl-8 pr-3 last:mb-0"
      data-testid="discount-adjustment-container"
    >
      <div className="flex justify-between items-start">
        <div className="flex">
          <div className="text-primary" data-testid="discount-icon">
            {type === "giftcard" && <CouponIcon />}
          </div>
          <div>
            <div
              className="text-sm text-black-light"
              data-testid="discount-label"
            >
              {label || (type === "giftcard" ? "Gift Card" : "Promo Code")}
            </div>
            {refundedAmount > 0 && (
              <div
                className="mt-1 text-xs text-red-600 font-medium"
                data-testid="refunded-amount"
              >
                <Currency value={refundedAmount} /> Refunded
              </div>
            )}
          </div>
        </div>
        <div className="text-right">
          <div className="text-sm text-red-600" data-testid="discount-amount">
            -<Currency value={displayAmount} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountAdjustment;
